import energia from '/public/assets/customers/energia.svg';
import energistyrelsen from '/public/assets/customers/energistyrelsen.svg';
import frederiksberg from '/public/assets/customers/frederiksberg.svg';
import horesta from '/public/assets/customers/horesta.svg';
import oister from '/public/assets/customers/oister.svg';
import visma from '/public/assets/customers/visma.svg';
import loginLeftSplash from '/public/assets/product-overlay.webp';
import loginRightSplash from '/public/assets/signup-2.webp';
import ParticlesAnimation from '~/components/ParticlesAnimation';

const LoginHero = () => (
  <div className="hidden h-full w-3/4 flex-col items-center justify-between bg-neutral-200 md:flex">
    <div className="absolute z-1">
      <svg fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_f_757_13304)">
          <path
            d="M839.772 1167.87C839.772 1367.79 878.699 1448.87 678.772 1448.87C478.845 1448.87 482.272 1349.29 482.272 1149.37C482.272 1051.66 204.351 688.492 267.272 623.367C302.221 587.193 652 558 670.5 261C713 560 968.324 585.867 1016.27 585.867C1216.2 585.867 839.772 967.94 839.772 1167.87Z"
            fill="#1F2436"
          />
        </g>
        <defs>
          <filter
            id="filter0_f_757_13304"
            x="-42"
            y="-39"
            width="1416.8"
            height="1787.87"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="150"
              result="effect1_foregroundBlur_757_13304"
            />
          </filter>
        </defs>
      </svg>
    </div>
    <div className="z-10 mt-12 flex flex-col items-center gap-4">
      <div className="h-auto w-[122px] text-white">
        <svg
          viewBox="0 0 240 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_7242_26917)">
            <path
              d="M214.036 24.0215C222.228 24.0215 228.604 26.4521 233.163 31.3136C237.722 36.1751 240.001 42.8597 240.001 51.3673C240.001 52.3682 239.966 53.3155 239.895 54.2092C239.828 55.0469 239.793 55.5548 239.789 55.7329L239.788 55.7641H202.175C202.246 57.4799 202.656 59.0706 203.404 60.5362C204.152 62.0018 205.114 63.2707 206.289 64.3431C207.465 65.4155 208.836 66.2556 210.403 66.8632C211.97 67.4709 213.645 67.7748 215.425 67.7748C216.769 67.7748 217.994 67.654 219.102 67.4122L225.331 78.2299C224.94 78.3801 224.541 78.5234 224.133 78.6595C221.462 79.5532 218.524 80 215.319 80C211.685 80 208.23 79.3745 204.953 78.1233C201.677 76.8722 198.792 75.0312 196.298 72.6006C193.805 70.1698 191.828 67.2029 190.368 63.6998C188.908 60.1966 188.178 56.2288 188.178 51.7962C188.178 47.5782 188.889 43.7534 190.314 40.3217C191.739 36.8901 193.644 33.9768 196.031 31.5818C198.417 29.1868 201.178 27.328 204.312 26.0054C207.447 24.6828 210.688 24.0215 214.036 24.0215ZM60.0562 24.0215C64.1879 24.0215 67.7141 24.5755 70.6349 25.6837C73.5555 26.7918 75.9241 28.2574 77.7407 30.0804C79.5571 31.9035 80.875 34.0304 81.6943 36.4611C82.4653 38.7489 82.8735 41.1317 82.9189 43.6094L82.9231 44.0751V70.0268L82.9265 70.5672C82.9421 71.8379 83.0121 73.177 83.1368 74.5845C83.2698 76.0858 83.4028 77.2913 83.5357 78.2011L83.5642 78.3914H70.528L70.4954 78.2217C70.3665 77.5237 70.2526 76.5972 70.154 75.4423C70.0471 74.1912 69.9937 73.0653 69.9937 72.0644C68.6403 74.1376 66.6991 75.9607 64.1701 77.5335C61.6412 79.1063 58.4178 79.8927 54.4998 79.8927C51.7216 79.8927 49.2105 79.446 46.9666 78.5523C44.7226 77.6586 42.8171 76.479 41.2498 75.0134C39.6826 73.5479 38.4894 71.8678 37.6702 69.9732C36.851 68.0787 36.4414 66.0948 36.4414 64.0215C36.4414 61.6622 36.851 59.5711 37.6702 57.748C38.4894 55.9249 39.6114 54.3343 41.0362 52.9759C42.4609 51.6175 44.1171 50.5452 46.0049 49.7587C47.7474 49.0328 49.6265 48.4896 51.6422 48.1292L52.1491 48.0429L65.0784 46.1126L65.2993 46.0787C66.6765 45.8528 67.6358 45.4173 68.1771 44.7721C68.7471 44.0929 69.032 43.2887 69.032 42.3592C69.032 40.5004 68.3019 38.8919 66.8415 37.5335C65.3812 36.1751 63.155 35.496 60.163 35.496C57.8553 35.496 55.9435 35.9611 54.4273 36.8912L47.7134 26.9106C48.6298 26.4206 49.6097 25.976 50.653 25.5764C53.36 24.5398 56.4945 24.0215 60.0562 24.0215ZM148.553 0C150.05 0 151.457 0.107239 152.774 0.321716C154.01 0.522788 154.917 0.755278 155.494 1.01919L155.606 1.07239V13.0831C155.249 12.9401 154.715 12.815 154.003 12.7078C153.291 12.6006 152.329 12.5469 151.118 12.5469C150.335 12.5469 149.515 12.6542 148.661 12.8686C147.805 13.0831 147.004 13.4584 146.256 13.9946C145.508 14.5308 144.902 15.2636 144.439 16.1931C144.005 17.0644 143.775 18.187 143.747 19.561L143.745 19.8391V25.6301H165.116V0.75067H179.328V59.4938H165.116V37.8552H143.745V78.3914H129.533V37.8552H109.231V78.3914H94.9125V37.8552H86.1505V25.6301H94.9125V19.6247C94.9125 16.622 95.3578 13.9232 96.2482 11.5282C97.1387 9.13316 98.4209 7.07774 100.095 5.36193C101.769 3.64611 103.782 2.3235 106.133 1.3941C108.483 0.464701 111.118 0 114.04 0C115.536 0 116.943 0.107239 118.26 0.321716C119.495 0.522788 120.402 0.755278 120.981 1.01919L121.092 1.07239V13.0831C120.736 12.9401 120.201 12.815 119.489 12.7078C118.776 12.6006 117.815 12.5469 116.604 12.5469C115.82 12.5469 115.002 12.6542 114.146 12.8686C113.292 13.0831 112.49 13.4584 111.742 13.9946C110.994 14.5308 110.388 15.2636 109.925 16.1931C109.492 17.0644 109.261 18.187 109.234 19.561L109.231 19.8391V25.6301H129.533V19.6247C129.533 13.6193 131.261 8.84718 134.716 5.30831C138.171 1.76944 142.783 0 148.553 0ZM69.032 54.3258L57.1712 56.5147C55.3191 56.8007 53.7696 57.462 52.523 58.4987C51.2763 59.5353 50.653 61.0902 50.653 63.1636C50.653 64.7364 51.2229 66.1483 52.3627 67.3994C53.5025 68.6506 55.2122 69.2761 57.4917 69.2761C58.9876 69.2761 60.4303 69.0795 61.8193 68.6864C63.2084 68.2931 64.4373 67.614 65.5058 66.6488C66.5744 65.6837 67.4292 64.4325 68.0703 62.8954C68.6794 61.4352 68.9992 59.604 69.0296 57.4017L69.032 57.0509V54.3258ZM214.249 35.6032C212.397 35.6032 210.759 35.9249 209.335 36.5684C207.91 37.2118 206.699 38.0339 205.702 39.0349C204.704 40.0358 203.938 41.1439 203.404 42.3592C202.914 43.4734 202.619 44.5875 202.518 45.7015L202.495 46.0054H226.004C225.933 44.7185 225.666 43.4495 225.202 42.1984C224.739 40.9473 224.027 39.8391 223.065 38.874C222.104 37.9088 220.893 37.1224 219.432 36.5147C217.972 35.9071 216.244 35.6032 214.249 35.6032Z"
              fill="#31374E"
            />
            <path
              d="M23.5415 24.5664C33.7797 24.5664 41.6686 29.8618 46.2651 39.555L46.4921 40.0433L33.1815 46.2157C30.9484 41.3181 28.0654 39.3409 23.5415 39.3409C17.7986 39.3409 14.7682 42.8788 14.6538 48.9143L14.6504 49.2721V78.7396H0V49.2721C0 35.3973 8.93905 24.5664 23.5415 24.5664Z"
              fill="#31374E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M184.089 78.7411C185.572 78.7411 186.966 78.6368 188.273 78.4282C189.579 78.2197 191.511 77.6636 192.077 77.3855C190.449 74.3871 189.336 72.3383 188.738 71.2388C187.138 68.2972 186.226 66.6272 186 66.2288C185.164 66.3331 184.562 66.3331 184.195 66.2288C183.644 66.0724 182.553 65.6553 181.812 65.1339C181.071 64.6126 180.47 63.9001 180.011 62.9965C179.552 62.0928 179.322 60.9111 179.322 59.4513V54.8047H165.113V59.6598C165.113 65.3797 166.875 69.949 170.165 73.3676L170.373 73.5797C173.797 77.0206 178.37 78.7411 184.089 78.7411Z"
              fill="#31374E"
            />
            <path
              d="M229.948 74.3306C232.377 74.3306 234.346 72.3563 234.346 69.9212C234.346 67.4859 232.377 65.5117 229.948 65.5117C227.52 65.5117 225.551 67.4859 225.551 69.9212C225.551 72.3563 227.52 74.3306 229.948 74.3306Z"
              fill="#8953FF"
            />
          </g>
          <defs>
            <clipPath id="clip0_7242_26917">
              <rect width="240" height="80" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <h1 className="text-m text-neutral-450 font-semibold">
        The Self-Service Automation Platform
      </h1>
    </div>

    <div
      className="relative flex items-center justify-center"
      style={{ opacity: 1 }}
    >
      <div className="productImgContainer2 z-10 flex justify-center gap-4">
        <img
          src={loginLeftSplash}
          alt="signup-splash-left"
          className="productImg imgLeft hidden max-h-[550px]! lg:block"
        />
        <img
          src={loginRightSplash}
          alt="signup-splash-right"
          className="productImg imgRight max-h-[550px]!"
        />
      </div>

      <div className="absolute top-0 right-0 h-full w-full">
        <ParticlesAnimation />
      </div>
    </div>

    <div className="z-10 mb-12 flex w-full flex-col items-center gap-12 overflow-hidden">
      <div className="flex flex-wrap justify-center gap-8">
        <img src={energia} alt="energia-logo" />
        <img src={oister} alt="oister-logo" />
        <img src={frederiksberg} alt="frederiksberg-logo" />
        <img src={energistyrelsen} alt="energistyrelsen-logo" />
        <img src={horesta} alt="horesta-logo" />
        <img src={visma} alt="visma-logo" />
      </div>
    </div>
  </div>
);

export default LoginHero;
